import React, { useState, useEffect } from 'react';
import { observer } from "mobx-react-lite"
import {
    Box,
    Button,
    Stack,
    Divider,
} from '@mui/material';
import { useDocumentStore } from 'store/RootProvider'
import FormConst from 'constants/FormConst';
import URLConst from 'constants/URLConst';
import Editor from 'utils/video/editor';

/*
 * Module - Document.js
 *
 * Description : 도움말 상세 내용 렌더링 모듈입니다. 
 *
 * 작성자 : Choi young ho. 
 * Created on Fri Sep 16 2022
 * Copyright (c) 2022 Renewhouse corp
 */
const Document = observer(({
    documentId
}) => {
    const documentStore = useDocumentStore();
    const [value, setValue] = useState('');
    const [oldValue, setOldValue] = useState('');

    // Document ID가 변경된 
    // 이벤트를 처리 합니다. 
    // 도움말 상세 내용을 갱신 합니다. 
    useEffect(() => {
        if (documentId == undefined || documentId == null) return;
        refreshContent();
    }, [documentId]);

    // 이미지 업로드 핸들러, modules 설정보다 위에 있어야 정상 적용
    const doRegImageCallBack = async (
        base64Str
    ) => {
        let imgUrl = null;
        try {
            let lst = [];
            lst.push(base64Str);

            let result = await documentStore.doInsertImg({
                documentId: documentId,
                imgList: lst,
            });
            let documentImgId = result[FormConst.LIST_FIELD][0].documentImgId;
            imgUrl = URLConst.DOCUMENT_IMAGE_DOWNLOAD_DATA
                + "?"
                + FormConst.DOCUMENT_IMG_ID
                + "=" + documentImgId;
        }
        catch (e) {
            console.log("[Document] Error", e);
        }
        return imgUrl;
    }

    /**
     * 도움말 상세 내용 
     * 갱신을 스토어에 요청 합니다.
     */
    const refreshContent = async () => {
        try {
            let result = await documentStore.doGetDocumentInfo({
                documentId: documentId
            });
            setOldValue(result[FormConst.OBJECT_FIELD].funcDesc);
        }
        catch (e) {
            console.log(e);
        }
    }

    /**
     * 도움말 관련 
     * 이미지 코드 리스트를 
     * 추출 합니다. 
     */
    const extrachImgIdList = () => {
        const regExp = /_document_img_id=.\d/g;
        let totalLst = value.match(regExp);

        let lst = [];
        totalLst?.forEach( str => {
            let idx = str.indexOf('=');
            lst.push(str.substring(idx + 1));
        })
        return lst;
    }

    /**
     * 도움말 상세 내용
     * 등록 / 수정을 
     */
    const doStore = async () => {
        try {
            let documentImgIdLst = extrachImgIdList();
            let result = await documentStore.doUpdate({
                documentId: documentId,
                documentFuncDesc: value,
                imgIdList : documentImgIdLst,
            });
            console.log(result);
            if(result[FormConst.ERROR_MSG] == "") {
                alert('저장하였습니다. ');
            }
            else {
                alert(result[FormConst.ERROR_MSG] );
            }
        }
        catch(e) {
            console.log(e);
            alert(e);
        }
    }

    return (
        <Box
            sx={{
                border: 1,
                p: 2,
            }}
        >
            <Stack spacing={2} direction="row"
                justifyContent="flex-end"
                divider={<Divider orientation="vertical" flexItem />}
                sx={{ m: 2 }}>
                <Button
                    variant="contained"
                    // disabled={!isEdited}
                    onClick={doStore}>
                    저장
                </Button>
            </Stack>

            <Editor
                value={oldValue}
                imgRegCallBack={doRegImageCallBack}
                onValueChangeCallBack={setValue}
            />
        </Box>
    );
});

export default Document;